import { MiscInvoiceProcessingPrePostReview } from "../MiscInvoiceProcessingPrePostReview";
import { MiscInvoiceProcessingPrintReview } from "../MiscInvoiceProcessingPrintReview";
import { Layout, Step, Stepper } from "@mcleod/components";

export abstract class AutogenLayoutMiscInvoiceProcessingStepper extends Layout {
    layoutMiscInvoiceProcessingPrePostReview: MiscInvoiceProcessingPrePostReview;
    layoutMiscInvoiceProcessingPrintReview: MiscInvoiceProcessingPrintReview;
    stepEditList: Step;
    stepPostingReports: Step;
    stepPrePostReview: Step;
    stepPrintReview: Step;
    stepperMiscInvoiceProcessing: Stepper;
}
